import ss from '@/utils/session-storage';
import ls from '@/utils/local-storage';

const bikeConnect = {
  namespaced: true,
  state: {
    connect: {
      frameNo: ss.getItem('frameNo'),
      bikeId: ss.getItem('bikeId'),
      deviceInfo: ss.getItem('deviceInfo'),
      bikeInfo: ss.getItem('bikeInfo'),
      currentDate: ss.getItem('date'),
      bikeIsRegister: ss.getItem('bikeIsRegister'),
      bikeUpdateStatus: ss.getItem('bikeUpdateStatus'),
      bikeConnSituation: ss.getItem('bikeConnSituation'),
      bikeConnectFail: ss.getItem('bikeConnectFail')
    },
    localStorageDeviceInfo: ls.getItem('localStorageDeviceInfo'),
    bikeFlag: ss.getItem('bikeFlag'),
    mgOpen: ss.getItem('mgOpen'),
    dongleFWVer: ss.getItem('dongleFWVer'),
    donglePartNumber: ss.getItem('donglePartNumber'),
    dongleNewFWVer: ss.getItem('dongleNewFWVer'),
    lang: ls.getItem('lang')
  },
  mutations: {
    getBikeId (state, data) {
      ss.setItem('bikeId', data);
      state.connect.bikeId = ss.getItem('bikeId');
    },
    setBikeId (state, data) {
      ss.setItem('bikeId', data);
      state.connect.bikeId = data;
    },
    getBikeInfo (state, data) {
      ss.setItem('bikeInfo', data);
      state.connect.bikeInfo = ss.getItem('bikeInfo');
    },
    getCurrentDate (state, data) {
      ss.setItem('date', data);
      state.connect.currentDate = ss.getItem('date');
    },
    getDeviceInfo (state, data) {
      ss.setItem('deviceInfo', data);
      state.connect.deviceInfo = ss.getItem('deviceInfo');
    },
    storeLocalDeviceInfo (state, data) {
      ls.setItem('localStorageDeviceInfo', data);
      state.localStorageDeviceInfo = ls.getItem('localStorageDeviceInfo');
    },
    updateDeviceInfo (state, data) {
      ss.setItem('deviceInfo', data);
      state.connect.deviceInfo = ss.getItem('deviceInfo');
    },
    updateBikeIsRegister (state, data) {
      ss.setItem('bikeIsRegister', data);
      state.connect.bikeIsRegister = ss.getItem('bikeIsRegister');
    },
    setBikeFlag (state, data) {
      ss.setItem('bikeFlag', data);
      state.bikeFlag = ss.getItem('bikeFlag');
    },
    setLang (state, data) {
      ls.setItem('lang', data);
      state.lang = ls.getItem('lang');
    },
    setBikeUpdateStatus (state, data) {
      ss.setItem('bikeUpdateStatus', data);
      state.connect.bikeUpdateStatus = data;
    },
    setBikeFrameNo (state, data) {
      ss.setItem('frameNo', data);
      state.connect.frameNo = data;
    },
    setBikeConnectSituation (state, data) {
      ss.setItem('bikeConnSituation', data);
      state.connect.bikeConnSituation = data;
    },
    getMGopen (state, data) {
      ss.setItem('mgOpen', data);
      state.mgOpen = ss.getItem('mgOpen');
    },
    setDGFWVer (state, data) {
      // console.log('currect DG',data);
      ss.setItem('dongleFWVer', data);
      state.dongleFWVer = data;
    },
    setDGNewFWVer (state, data) {
      ss.setItem('dongleNewFWVer', data);
      state.dongleNewFWVer = data;
    },
    setConnFail (state, data) {
      // console.log(data);
      ss.setItem('bikeConnectFail', data);
      state.connect.bikeConnectFail = data;
    },
    setDGPart(state,data){
      ss.setItem('donglePartNumber', data);
      state.donglePartNumber = data;
    }
  },
  actions: {
    getBikeId ({ commit }, data) {
      commit('getBikeId', data);
    },
    getBikeInfo ({ commit }, data) {
      commit('getBikeInfo', data);
    },
    setBikeId ({ commit }, data) {
      commit('setBikeId', data);
    },
    getCurrentDate ({ commit }, data) {
      commit('getCurrentDate', data);
    },
    getDeviceInfo ({ commit }, data) {
      commit('getDeviceInfo', data);
    },
    storeLocalDeviceInfo ({ commit }, data) {
      commit('storeLocalDeviceInfo', data);
    },
    updateDeviceInfo ({ commit }, data) {
      commit('updateDeviceInfo', data);
    },
    updateBikeIsRegister ({ commit }, data) {
      commit('updateBikeIsRegister', data);
    },
    setBikeFlag ({ commit }, data) {
      commit('setBikeFlag', data);
    },
    setLang ({ commit }, data) {
      commit('setLang', data);
    },
    setBikeRegisterData ({ commit }, data) {
      commit('setBikeRegisterData', data);
    },
    setBikeUpdateStatus ({ commit }, data) {
      // console.log('Vuex', data)
      commit('setBikeUpdateStatus', data);
    },
    setBikeFrameNo ({ commit }, data) {
      commit('setBikeFrameNo', data);
    },
    setBikeConnectSituation ({ commit }, data) {
      // console.log('Vuex setBikeConnectSituation')
      commit('setBikeConnectSituation', data);
    },
    getMGopen ({ commit }, data) {
      // console.log('getMGopen', data)
      commit('getMGopen', data);
    },
    setDGFWVer ({ commit }, data) {
      commit('setDGFWVer', data);
    },
    setDGNewFWVer ({ commit }, data) {
      commit('setDGNewFWVer', data);
    },
    setConnFail ({ commit }, data) {
      commit('setConnFail', data);
    },
    setDGPartNumber({commit}, data){
      commit('setDGPart',data)
    }
  },
  getters: {
    getBikeId: state => state.connect.bikeId,
    getBikeInfo: state => state.connect.bikeInfo,
    getDeviceInfo: state => state.connect.deviceInfo,
    getCurrentDate: state => state.connect.currentDate,
    updateBikeIsRegister: state => state.connect.bikeIsRegister,
    getBikeFlag: state => state.bikeFlag,
    getLang: state => state.lang,
    getBikeUpdateStatus: state => state.connect.bikeUpdateStatus,
    getBikeFrameNo: state => state.connect.frameNo,
    getBikeConnSituation: state => state.connect.bikeConnSituation,
    getLocalStoreDeviceInfo: state => state.localStorageDeviceInfo,
    getMGopen: state => state.mgOpen,
    getDGFWVer: state => state.dongleFWVer,
    getDGNewFWVer: state => state.dongleNewFWVer,
    getConnFail: state => state.connect.bikeConnectFail,
    getDGPartNumber: state => state.donglePartNumber
  }
};

export default bikeConnect;
